/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */


import CostBoxForm from "../../DivorceCalculator/CostBox";
import PageHeadline from "../../PageHeadline/PageHeadline";
import PageContentContainer from "../../Container/PageContentContainer";
import ContentBox from "../../ContentBox/ContentBox";

export default function DivorceCalculatorPage() {
  return (
    <PageContentContainer size={"tiny"}>
      <PageHeadline main="Scheidungskosten berechnen" />
      <ContentBox>
        <CostBoxForm />
      </ContentBox>
    </PageContentContainer>
  );
}
